import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import MenuItem from './menu-item';

const MenuColumn = (props) => {
  return (
    <ul className={ classNames('post-login-menu-column-component', props.className) }>
      { props.title ?
        <li className="menu-column-title">{ props.title }</li> :
        null
      }
      { props.children }
    </ul>
  );
};

MenuColumn.propTypes = {
  className: PropTypes.string,
  title: PropTypes.string,
  children: PropTypes.arrayOf(MenuItem)
};

export default MenuColumn;
